module.exports = __webpack_public_path__ + "img/4.9.TU.9c52212c.png";